<template>
  <div>
    <p>
      🤩 מעוניינים להגיש מועמדות? 🤩
      <br>
      להגשת מועמדות >> {{position_link}}
      <br>
      <br>
      🔍 לקבלת עדכונים חמים, תכנים מקצועיים וטיפים לחיפוש עבודה מומלץ לעקוב אחרינו 👍 :
      <br>
      <br>
      🟣 לעמוד הפייסבוק: https://www.facebook.com/PiolaHr
      <br>
      🟣 לעמוד הלינקדאין : https://www.linkedin.com/company/piolahr
      <br>
      <br>
      🟣 לצפייה במשרות חמות בעולם הכספים והאדמיניסטרציה: https://www.piola.co.il/positions
      <br>
      ⭐ משרות משפטיות - https://www.facebook.com/suitup.co.il - SUITUP
      <br>
      🟣 לערוץ הטלגרם : https://t.me/+PJzydcNBMkw1NDI0
      <br>
    </p>
  </div>
</template>
<script>
export default {
  name: 'piola-footer',
  props: ['position', 'position_link']
}
</script>
